import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type LookupItem = {
  id: number;
  displayText: string;
};

export type AccessorialLookupItem = {
  accessorialId: number;
  displayText: string;
  accessorialTypeId: number;
};

export type EquipmentDisplayField = {
  id: number;
  values: EquipmentMappingValue[];
};

export type EquipmentMappingValue = {
  id: number;
  displayFields: Maybe<EquipmentDisplayField[]>;
};

export type EquipmentMappingItem = {
  id: number;
  displayFields: EquipmentDisplayField[];
};

/** Bootstrap: all five GTZ lookups in one response (equipment types, mapping, lengths, display fields, accessorials). */
export type BootstrapResponse = {
  equipmentTypes: LookupItem[];
  equipmentMapping: EquipmentMappingItem[];
  equipmentLengths: LookupItem[];
  displayFields: LookupItem[];
  accessorials: AccessorialLookupItem[];
};

export async function getBootstrapGlobalTranz(
  tmsID: number,
  options?: { quoteModeTypeEnum?: number; hardRefresh?: boolean }
): Promise<Result<BootstrapResponse, ApiError>> {
  const quoteModeTypeEnum = options?.quoteModeTypeEnum ?? 3;
  const hardRefresh = options?.hardRefresh ?? false;
  const params = new URLSearchParams({
    tmsID: String(tmsID),
    quoteModeTypeEnum: String(quoteModeTypeEnum),
    hardRefresh: String(hardRefresh),
  });
  try {
    const response = await axios.get<BootstrapResponse>(
      `/load/globaltranz/bootstrap?${params.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getBootstrapGlobalTranz' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to fetch GTZ reference data' });
    }

    if (error?.response?.status === 401) {
      throw error;
    }

    if (error?.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message:
        (error.response?.data as { message?: string })?.message ||
        'Failed to fetch GTZ reference data',
    });
  }
}
